import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import Logo from "../../components/Logo";
import { motion } from "motion/react";
import FormInput from "../../components/FormInput";
import Button from "../../components/Button";
import { useMutation } from "@apollo/client";
import { CreatePasswordResetDocument } from "../../__generated__/graphql";
import { toast } from "react-hot-toast";

const askResetPasswordSchema = z.object({
  email: z.string().email("Adresse email invalide"),
});

export type AskResetPasswordFormData = z.infer<typeof askResetPasswordSchema>;

export default function AskResetPassword() {
  const [createPasswordReset, { loading: isLoading }] = useMutation(
    CreatePasswordResetDocument
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<AskResetPasswordFormData>({
    resolver: zodResolver(askResetPasswordSchema),
  });

  const onSubmit = async (data: AskResetPasswordFormData) => {
    try {
      await createPasswordReset({ variables: { email: data.email } });
      toast.success("Lien de réinitialisation envoyé avec succès");
    } catch (error) {
      toast.error(
        error instanceof Error ? error.message : "Une erreur est survenue"
      );
    }
  };

  return (
    <div className="flex flex-col justify-center items-center h-screen gap-4 bg-background">
      <Logo />
      <motion.div
        className="w-full max-w-md bg-dark border border-border rounded-lg px-4 py-8 text-primary"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-xl font-bold mb-6 text-center">
          Réinitialiser votre mot de passe
        </h1>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <FormInput
            id="email"
            label="Email"
            type="email"
            register={register}
            error={errors.email}
          />
          <Button
            type="submit"
            isLoading={isLoading}
            className="w-full h-12 mt-8"
          >
            Envoyer le lien de réinitialisation
          </Button>
        </form>
      </motion.div>
    </div>
  );
}
